export enum ProposalNameDisplayOptionStatus {
    JobType = 0,
    ServiceAddress = 1,
    LocationName = 2,
}

export const getProposalNameDisplay = (
    jobNumberAndType: string | undefined,
    opportunityId: string | undefined,
    serviceLocationAddress: string | undefined,
    locationName: string | undefined,
    proposalNameDisplayStatus?: ProposalNameDisplayOptionStatus
): string | null => {
    if (proposalNameDisplayStatus === undefined) {
        return null;
    }

    switch (proposalNameDisplayStatus) {
        case ProposalNameDisplayOptionStatus.JobType:
            return jobNumberAndType ?? null;
        case ProposalNameDisplayOptionStatus.ServiceAddress:
            return opportunityId && serviceLocationAddress
                ? `${opportunityId}: ${serviceLocationAddress}`
                : null;
        case ProposalNameDisplayOptionStatus.LocationName:
            return opportunityId && locationName ? `${opportunityId}: ${locationName}` : null;
        default:
            return null;
    }
};
